import { Fragment, type ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface Field {
  label: string;
  value: ReactNode;
  /** Ids, URLs, hashes: monospace and allowed to break anywhere. */
  mono?: boolean;
}

/**
 * Key/value detail list. Below `md` each label sits above its value (small
 * caps label); from `md` up, labels form a left column.
 */
export function FieldList({ fields }: { fields: Field[] }) {
  return (
    <dl className="grid grid-cols-1 gap-y-3 text-sm md:grid-cols-[minmax(120px,max-content)_minmax(0,1fr)] md:gap-x-6 md:gap-y-2">
      {fields.map((field) => (
        <Fragment key={field.label}>
          <dt className="text-xs font-medium uppercase tracking-wide text-muted-foreground md:text-sm md:font-normal md:normal-case md:tracking-normal">
            {field.label}
          </dt>
          {/* -mt-2.5: on phone the value hugs its label (2px), pairs stay 12px apart. */}
          <dd className={cn('-mt-2.5 min-w-0 break-words md:mt-0', field.mono && 'font-mono text-xs break-all')}>
            {field.value}
          </dd>
        </Fragment>
      ))}
    </dl>
  );
}
